import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setTrasporti,
  addTrasporti,
  updateTrasporti,
  deleteTrasporti,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  enumRequestStart,
  setViaggio,
  enumRequestSuccess,
  setMezzoViaggo,
  enumRequestFailure,
  setTrattori,
  addTrasportiId,
} from "./trasportiSlice"

import trasportoAPI from "../../services/trasportoAPI"
import { toast } from "react-toastify";

export const fetchTrasporti = createAsyncThunk(
  "trasportoData/fetchTrasporti",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await trasportoAPI.getAllViago()
      dispatch(setTrasporti(response.data.data));
      console.log(response.data.data, "data ")
      dispatch(apiRequestSuccess());
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to fetch"
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
)

export const singleTrasporti = createAsyncThunk(
  "trasporti/fetchSingleTrasporti",
  async (trasportoId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await trasportoAPI.getSingleViaggio(trasportoId);
      // Make sure we're storing the data properly in state
      dispatch(addTrasportiId(response.data.data));

      // Add logging to debug
      console.log("Single trasporto data:", response.data.data);

      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch single trasporto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
)

export const createViagio = createAsyncThunk(
  "trasportoData/createViagio",
  async (payload, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await trasportoAPI.createViago(payload);
      dispatch(addTrasporti(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create trasporto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const updateTrasportoData = createAsyncThunk(
  "trasportoData/updateTrasporto",
  async ({ id, data }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await trasportoAPI.updateViaggo(id, data);
      dispatch(updateTrasporti(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update trasporto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
export const deleteTrasportoData = createAsyncThunk(
  "trasportoData/deleteTrasporto",
  async (id, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response =  await trasportoAPI.deleteViaggio(id);
      dispatch(deleteTrasporti(id));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return id;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete trasporto.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const fetchViaggio = createAsyncThunk(
  "trasportoData/fetchViaggio",
  async (id, { dispatch }) => {
    dispatch(enumRequestStart("viaggio"));
    try {
      const response = await trasportoAPI.getViago();
      dispatch(setViaggio(response.data.data));
      dispatch(enumRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch viaggio.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
)
export const fetchMezzoViaggio = createAsyncThunk(
  "trasportoData/fetchMezzoViaggio",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("mezzoViaggio"));
    try {
      const response = await trasportoAPI.getMezzoviaggio()
      dispatch(setMezzoViaggo(response.data.data));
      dispatch(enumRequestSuccess("mezzoViaggio"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch mezzoViaggio.";
      dispatch(
        enumRequestFailure({
          enumType: "mezzoViaggio",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  }
);

export const fetchTrattori = createAsyncThunk(
  "trasportoData/fetchTrattori",
  async (_, { dispatch }) => {
    dispatch(enumRequestStart("trattori"));
    try {
      const response = await trasportoAPI.getTrattori()
      dispatch(setTrattori(response.data.data));
      dispatch(enumRequestSuccess("trattori"));
      return response.data.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch trattori.";
      dispatch(
        enumRequestFailure({
          enumType: "trattori",
          error: errorMessage,
        })
      );
      throw new Error(errorMessage);
    }
  }
);
